<div class="mt-6" *transloco="let t">
  <div class="mb-8 flex">
    <span class="grow text-xl font-semibold">
      {{
        t(
          isPrecuratedTraining
            ? 'portal.trainings.builder.stepper.courseSelection.predefinedHeadline'
            : 'portal.trainings.builder.stepper.courseSelection.headline'
        )
      }}
    </span>
    @if (isEditable) {
      <button
        type="button"
        class="flex items-center justify-center gap-2 rounded-lg border-2 border-grey-midGrey bg-white px-4 py-2 text-sm font-semibold hover:bg-grey-veryLightGrey"
        (click)="onSelectCourseClickedEvent()"
        title="{{
          t(
            'portal.trainings.builder.stepper.courseSelection.selectCourseButton'
          )
        }}"
      >
        <mat-icon class="material-icons-outlined text-grey">add</mat-icon>
        <span>{{
          t(
            'portal.trainings.builder.stepper.courseSelection.selectCourseButton'
          )
        }}</span>
      </button>
    }
  </div>
  <app-arrow-wrapper [arrowRedrawSignal]="arrowRedrawTrigger">
    <div
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
      class="mb-10 space-y-4"
    >
      @for (
        phaseGroup of dataService.getPhasesArray().controls;
        track phaseGroup;
        let i = $index
      ) {
        <div
          class="element_with_arrowhead"
          [attr.data-index]="i"
          cdkDrag
          [cdkDragDisabled]="!isEditable"
        >
          <div
            class="mb-10 rounded-lg border border-grey-lightGrey bg-grey-veryLightGrey px-10 py-4"
          >
            <div class="flex items-center justify-between gap-10">
              <!-- Drag handle -->
              @if (isEditable) {
                <button
                  class="cursor-move touch-none p-1 text-grey-midGrey hover:text-grey"
                  cdkDragHandle
                  type="button"
                >
                  <svg class="size-5" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M7 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM7 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM13 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM13 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM13 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                    />
                  </svg>
                </button>
              }

              <!-- Phase label -->
              <div
                class="rounded-lg border border-grey-lightGrey px-4 py-2 text-sm font-medium text-grey"
              >
                {{ getPhaseName(i) }}
              </div>

              <!-- Course display or add button -->
              <div class="flex-1">
                <app-course-select
                  [control]="phaseGroup.controls.course"
                  [label]="
                    t(
                      'portal.trainings.builder.stepper.courseSelection.selectCourseButton'
                    )
                  "
                  [isEditable]="isEditable"
                  (selectCourse)="onCourseSelectorButtonClickedEvent(i)"
                  (removeCourse)="onRemoveCourseButtonClickedEvent(i)"
                />
              </div>
              @if (isEditable) {
                <button
                  mat-menu-item
                  [disabled]="dataService.getPhasesArray().controls.length <= 1"
                  [class.opacity-50]="
                    dataService.getPhasesArray().controls.length <= 1
                  "
                  [class.cursor-not-allowed]="
                    dataService.getPhasesArray().controls.length <= 1
                  "
                  [matTooltip]="
                    dataService.getPhasesArray().controls.length <= 1 &&
                    t(
                      'portal.trainings.builder.stepper.courseSelection.deletePhaseDisabledTooltip'
                    )
                  "
                  [matTooltipDisabled]="
                    dataService.getPhasesArray().controls.length > 1
                  "
                  (click)="onRemovePhaseButtonClickedEvent(i)"
                >
                  <mat-icon class="material-icons-outlined text-cancel">
                    delete_forever
                  </mat-icon>
                </button>
              }
            </div>
          </div>

          <!-- Drag placeholder -->
          <div *cdkDragPlaceholder>
            <div
              class="mb-10 h-[124px] rounded-lg border-2 border-dashed border-blue-mid bg-blue-veryLight"
            ></div>
          </div>
        </div>
      }
    </div>

    <!-- Loop toggle -->
    <div class="element_with_line flex justify-center">
      <div
        class="inline-flex items-center gap-3 rounded-lg border border-grey-lightGrey bg-grey-veryLightGrey px-6 py-4"
      >
        <app-slide-toggle
          [checked]="dataService.formGroupCourseSelection.controls.loop.value"
          (checkedChange)="
            dataService.formGroupCourseSelection.controls.loop.setValue($event)
          "
        />
        <svg
          class="size-5 text-grey"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        <div class="flex-row">
          <div class="text-sm font-medium">
            {{
              t('portal.trainings.builder.stepper.courseSelection.loopToggle')
            }}
          </div>
          <div
            class="text-xs text-grey"
            [innerHTML]="
              t(
                'portal.trainings.builder.stepper.courseSelection.loopToggleExplanation'
              )
            "
          ></div>
        </div>
      </div>
    </div>
  </app-arrow-wrapper>
</div>
